
import { fetchUserDetails } from '../../network/userRequests'

// initial state
const state = {
	memberDetails: null,
	canTransact: false,
	last_logged_in: null,
	goldExpiration: null,
}

// getters
const getters = {
	firstName:  state => state.memberDetails ? state.memberDetails.given_name : ''
}

// actions
const actions = {
	//fetch reference object from server
	getMemberDetails({ commit }) {
		return new Promise((resolve, reject) => {
			fetchUserDetails(member => {
				commit("setMember", member.member_details)
				resolve()
			})
		})
	},
	getCachedMemberDetails({dispatch, state}){
		if(state.memberDetails){
			return Promise.resolve(state.memberDetails)
		}else{
			return dispatch("getMemberDetails")
		}
	}
}

// mutations
const mutations = {
	setMember(state, memberDetails) {
		state.memberDetails = memberDetails;
	},
	setTransactionState(state, canTransact) {
		state.canTransact = canTransact;
	},
	setLastLoggedin(state, last_logged_in) {
		state.last_logged_in = last_logged_in;
	},
	setGoldExpiration(state, goldExpiration) {
		state.goldExpiration = goldExpiration;
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}